var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAction1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 155,
    viewBox: "0 0 173 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5589,
    cy: 77.5247,
    r: 70.1468,
    fill: "#FFF9E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.227 154.947L144.922 77.9145L133.831 57.6608L131.227 41.3617L156.702 32.8814L159.209 0.492188H166.554V34.5872L172.994 55.8018L164.549 77.9145L164.103 154.947H131.227Z",
    fill: "#FFE4BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7473 135.034L40.3255 54.6666L51.3123 31.2798L19.4173 13.999L8.74391 29.2468L0.855469 29.755V52.6266L15.3513 55.6831L21.3181 135.034H55.7473Z",
    fill: "#FFE4BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7012 151.549L71.7679 85.9352L68.1544 68.7589L96.7909 41.9326L111.147 50.3711L106.134 52.1813H95.8858L86.5422 68.7589L100.244 82.6211H106.134V87.1467L88.6448 91.0665L90.3228 151.549H56.7012Z",
    fill: "#FFE4BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.244 53.6856V82.6214L157.002 79.3073L154.363 46.751L100.244 53.6856Z",
    fill: "#107393"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.113 52.4045V41.1045H130.015L135.981 50.8589L117.113 52.4045Z",
    fill: "#107393"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.549 77.72C134.527 77.72 140.996 72.4707 140.996 65.9953C140.996 59.5199 134.527 54.2705 126.549 54.2705C118.57 54.2705 112.102 59.5199 112.102 65.9953C112.102 72.4707 118.57 77.72 126.549 77.72Z",
    fill: "#D9E0A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.549 75.9091C132.025 75.9091 136.464 71.4702 136.464 65.9946C136.464 60.519 132.025 56.0801 126.549 56.0801C121.074 56.0801 116.635 60.519 116.635 65.9946C116.635 71.4702 121.074 75.9091 126.549 75.9091Z",
    fill: "#107393"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.548 73.0757C130.458 73.0757 133.628 69.9055 133.628 65.9949C133.628 62.0842 130.458 58.9141 126.548 58.9141C122.637 58.9141 119.467 62.0842 119.467 65.9949C119.467 69.9055 122.637 73.0757 126.548 73.0757Z",
    fill: "#D9E0A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.467 44.7033L120.261 50.2245H130.46L129.131 43.457L119.467 44.7033Z",
    fill: "#D9E0A2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7476 135.034L48.6111 151.549H3.25781L21.3184 135.034",
    fill: "#FFE4BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction1);
export default __webpack_public_path__ + "static/media/action1.eb1caa07a5f93567bc0117dd325f6acb.svg";
export { ForwardRef as ReactComponent };